export enum TasksCategory {
  LATE = 1,
  TODAY = 2,
  TOMORROW_UP_TO_7_DAYS = 3,
  MORE_THAN_7_DAYS = 4,
}
